import { render, staticRenderFns } from "./RuleView.vue?vue&type=template&id=d4948a64"
import script from "./RuleView.ts?vue&type=script&lang=ts&external"
export * from "./RuleView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports